__turbopack_context__.v({
  "blogDetailActionButton": "v1-module-scss-module__kqebrG__blogDetailActionButton",
  "blogDetailActionIcon": "v1-module-scss-module__kqebrG__blogDetailActionIcon",
  "blogDetailActions": "v1-module-scss-module__kqebrG__blogDetailActions",
  "blogDetailArticle": "v1-module-scss-module__kqebrG__blogDetailArticle",
  "blogDetailArticleCard": "v1-module-scss-module__kqebrG__blogDetailArticleCard",
  "blogDetailArticleInner": "v1-module-scss-module__kqebrG__blogDetailArticleInner",
  "blogDetailBackIcon": "v1-module-scss-module__kqebrG__blogDetailBackIcon",
  "blogDetailBackLink": "v1-module-scss-module__kqebrG__blogDetailBackLink",
  "blogDetailBadge": "v1-module-scss-module__kqebrG__blogDetailBadge",
  "blogDetailBadgeRow": "v1-module-scss-module__kqebrG__blogDetailBadgeRow",
  "blogDetailHeaderInner": "v1-module-scss-module__kqebrG__blogDetailHeaderInner",
  "blogDetailHeaderSection": "v1-module-scss-module__kqebrG__blogDetailHeaderSection",
  "blogDetailLead": "v1-module-scss-module__kqebrG__blogDetailLead",
  "blogDetailMeta": "v1-module-scss-module__kqebrG__blogDetailMeta",
  "blogDetailMetaAuthor": "v1-module-scss-module__kqebrG__blogDetailMetaAuthor",
  "blogDetailMetaIcon": "v1-module-scss-module__kqebrG__blogDetailMetaIcon",
  "blogDetailMetaItem": "v1-module-scss-module__kqebrG__blogDetailMetaItem",
  "blogDetailProse": "v1-module-scss-module__kqebrG__blogDetailProse",
  "blogDetailRelatedCard": "v1-module-scss-module__kqebrG__blogDetailRelatedCard",
  "blogDetailRelatedCardExcerpt": "v1-module-scss-module__kqebrG__blogDetailRelatedCardExcerpt",
  "blogDetailRelatedCardTitle": "v1-module-scss-module__kqebrG__blogDetailRelatedCardTitle",
  "blogDetailRelatedGrid": "v1-module-scss-module__kqebrG__blogDetailRelatedGrid",
  "blogDetailRelatedIcon": "v1-module-scss-module__kqebrG__blogDetailRelatedIcon",
  "blogDetailRelatedIconAccent": "v1-module-scss-module__kqebrG__blogDetailRelatedIconAccent",
  "blogDetailRelatedInner": "v1-module-scss-module__kqebrG__blogDetailRelatedInner",
  "blogDetailRelatedLink": "v1-module-scss-module__kqebrG__blogDetailRelatedLink",
  "blogDetailRelatedMeta": "v1-module-scss-module__kqebrG__blogDetailRelatedMeta",
  "blogDetailRelatedSection": "v1-module-scss-module__kqebrG__blogDetailRelatedSection",
  "blogDetailRelatedStat": "v1-module-scss-module__kqebrG__blogDetailRelatedStat",
  "blogDetailRelatedTitle": "v1-module-scss-module__kqebrG__blogDetailRelatedTitle",
  "blogDetailTitle": "v1-module-scss-module__kqebrG__blogDetailTitle",
  "blogsCardBadge": "v1-module-scss-module__kqebrG__blogsCardBadge",
  "blogsCardContent": "v1-module-scss-module__kqebrG__blogsCardContent",
  "blogsCardDate": "v1-module-scss-module__kqebrG__blogsCardDate",
  "blogsCardExcerpt": "v1-module-scss-module__kqebrG__blogsCardExcerpt",
  "blogsCardFooter": "v1-module-scss-module__kqebrG__blogsCardFooter",
  "blogsCardLink": "v1-module-scss-module__kqebrG__blogsCardLink",
  "blogsCardLinkIcon": "v1-module-scss-module__kqebrG__blogsCardLinkIcon",
  "blogsCardMeta": "v1-module-scss-module__kqebrG__blogsCardMeta",
  "blogsCardRow": "v1-module-scss-module__kqebrG__blogsCardRow",
  "blogsCardStat": "v1-module-scss-module__kqebrG__blogsCardStat",
  "blogsCardStatIcon": "v1-module-scss-module__kqebrG__blogsCardStatIcon",
  "blogsCardStatIconAccent": "v1-module-scss-module__kqebrG__blogsCardStatIconAccent",
  "blogsCardStats": "v1-module-scss-module__kqebrG__blogsCardStats",
  "blogsCardTitle": "v1-module-scss-module__kqebrG__blogsCardTitle",
  "blogsFeaturedCard": "v1-module-scss-module__kqebrG__blogsFeaturedCard",
  "blogsHeroInner": "v1-module-scss-module__kqebrG__blogsHeroInner",
  "blogsHeroSection": "v1-module-scss-module__kqebrG__blogsHeroSection",
  "blogsHeroSubtitle": "v1-module-scss-module__kqebrG__blogsHeroSubtitle",
  "blogsHeroTitle": "v1-module-scss-module__kqebrG__blogsHeroTitle",
  "blogsListInner": "v1-module-scss-module__kqebrG__blogsListInner",
  "blogsListSection": "v1-module-scss-module__kqebrG__blogsListSection",
  "blogsLoadMore": "v1-module-scss-module__kqebrG__blogsLoadMore",
  "blogsPostCard": "v1-module-scss-module__kqebrG__blogsPostCard",
  "blogsPostCategory": "v1-module-scss-module__kqebrG__blogsPostCategory",
  "blogsPostDate": "v1-module-scss-module__kqebrG__blogsPostDate",
  "blogsPostExcerpt": "v1-module-scss-module__kqebrG__blogsPostExcerpt",
  "blogsPostFooter": "v1-module-scss-module__kqebrG__blogsPostFooter",
  "blogsPostLink": "v1-module-scss-module__kqebrG__blogsPostLink",
  "blogsPostLinkIcon": "v1-module-scss-module__kqebrG__blogsPostLinkIcon",
  "blogsPostMeta": "v1-module-scss-module__kqebrG__blogsPostMeta",
  "blogsPostStat": "v1-module-scss-module__kqebrG__blogsPostStat",
  "blogsPostStatIcon": "v1-module-scss-module__kqebrG__blogsPostStatIcon",
  "blogsPostStatIconAccent": "v1-module-scss-module__kqebrG__blogsPostStatIconAccent",
  "blogsPostStats": "v1-module-scss-module__kqebrG__blogsPostStats",
  "blogsPostTitle": "v1-module-scss-module__kqebrG__blogsPostTitle",
  "blogsPostsGrid": "v1-module-scss-module__kqebrG__blogsPostsGrid",
  "footer": "v1-module-scss-module__kqebrG__footer",
  "footerBottom": "v1-module-scss-module__kqebrG__footerBottom",
  "footerBrand": "v1-module-scss-module__kqebrG__footerBrand",
  "footerColumn": "v1-module-scss-module__kqebrG__footerColumn",
  "footerCopyright": "v1-module-scss-module__kqebrG__footerCopyright",
  "footerGrid": "v1-module-scss-module__kqebrG__footerGrid",
  "footerHeading": "v1-module-scss-module__kqebrG__footerHeading",
  "footerInner": "v1-module-scss-module__kqebrG__footerInner",
  "footerLegal": "v1-module-scss-module__kqebrG__footerLegal",
  "footerLinks": "v1-module-scss-module__kqebrG__footerLinks",
  "footerLogo": "v1-module-scss-module__kqebrG__footerLogo",
  "footerLogoImage": "v1-module-scss-module__kqebrG__footerLogoImage",
  "footerTagline": "v1-module-scss-module__kqebrG__footerTagline",
  "header": "v1-module-scss-module__kqebrG__header",
  "headerInner": "v1-module-scss-module__kqebrG__headerInner",
  "headerScrolled": "v1-module-scss-module__kqebrG__headerScrolled",
  "legalContainer": "v1-module-scss-module__kqebrG__legalContainer",
  "legalInner": "v1-module-scss-module__kqebrG__legalInner",
  "logoContainer": "v1-module-scss-module__kqebrG__logoContainer",
  "logoImage": "v1-module-scss-module__kqebrG__logoImage",
  "menuButton": "v1-module-scss-module__kqebrG__menuButton",
  "mobileNav": "v1-module-scss-module__kqebrG__mobileNav",
  "mobileNavLink": "v1-module-scss-module__kqebrG__mobileNavLink",
  "mobileNavList": "v1-module-scss-module__kqebrG__mobileNavList",
  "mobileNavOpen": "v1-module-scss-module__kqebrG__mobileNavOpen",
  "nav": "v1-module-scss-module__kqebrG__nav",
  "navLink": "v1-module-scss-module__kqebrG__navLink",
  "v1Page": "v1-module-scss-module__kqebrG__v1Page",
});
